import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { PUBLIC_DEALS_RETAILERS } from "../../config/publicDeals";
import { HF, liftOnDark, retailerLabel } from "./homeFeedUi";

const TILE = HF.surface2;
const MUTED = HF.text3;

/** "/stores": every online store with a public deals feed, A–Z, with a name filter. */
export default function AllStores() {
  const [term, setTerm] = useState("");
  const stores = useMemo(() => {
    const needle = term.trim().toLowerCase();
    return [...PUBLIC_DEALS_RETAILERS]
      .sort((a, b) => retailerLabel(a).localeCompare(retailerLabel(b)))
      .filter((r) => !needle || retailerLabel(r).toLowerCase().includes(needle) || r.name.toLowerCase().includes(needle));
  }, [term]);

  return (
    <section className="flex flex-col gap-5" data-testid="all-stores">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="flex flex-col gap-1">
          <h1 className="m-0 text-[26px] font-extrabold tracking-[-0.6px] sm:text-[32px] sm:tracking-[-0.8px]">All online stores</h1>
          <p className="m-0 text-[14.5px] sm:text-[15px]" style={{ color: MUTED }}>
            {PUBLIC_DEALS_RETAILERS.length} stores, free to browse, no account needed
          </p>
        </div>
        <label className="flex h-11 w-full items-center gap-2 rounded-full border bg-[var(--hf-surface)] px-4 sm:w-[300px]" style={{ borderColor: HF.chipBorder }}>
          <span className="sr-only">Find a store</span>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke={MUTED} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-3.5-3.5" />
          </svg>
          <input
            type="search"
            value={term}
            onChange={(e) => setTerm(e.target.value)}
            placeholder="Find a store"
            className="min-w-0 flex-1 border-0 bg-transparent text-base outline-none placeholder:text-[var(--hf-placeholder)] sm:text-[15px]"
            style={{ color: HF.ink }}
          />
        </label>
      </div>
      {stores.length === 0 ? (
        <p className="m-0 py-10 text-center text-[15px]" style={{ color: MUTED }}>No store matches “{term.trim()}”.</p>
      ) : (
        <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4 sm:gap-3 lg:grid-cols-6">
          {stores.map((retailer) => (
            <Link
              key={retailer.slug}
              to={`/${retailer.slug}`}
              className="flex h-[64px] items-center justify-center rounded-[16px] px-3 text-center no-underline transition-colors hover:bg-[var(--hf-hover-strong)] sm:h-[76px] sm:rounded-[18px]"
              style={{ background: TILE }}
            >
              <span className="text-[15px] font-extrabold tracking-[-0.2px] sm:text-[16px]" style={{ color: liftOnDark(retailer.accent) }}>
                {retailerLabel(retailer)}
              </span>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}
